import React from 'react';
import logo from '../../logo.svg';

const Logo = () => {

  return (
    <img src={logo} className="header__logo" width="40" height="40" alt="logo" />
  );
};

export default Logo;
